import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { LeftArrow } from 'components/CommonIcons';

import * as styles from './DrawerControl.scss';

/**
 * Reusable Drawer Control Component
 * @function DrawerControl
 * @param {Object}
 * @return {ReactElement}
 */
const DrawerControl = ({ className, onClick, open, style }) => {
  return (
    <div
      className={classNames(styles.drawerControl, className)}
      onClick={onClick}
      style={style}
    >
      <LeftArrow
        className={classNames(
          styles.drawerArrow,
          { [styles.drawerArrowOpen]: open }
        )}
        height={25}
        width={25} />
    </div>
  );
};

DrawerControl.propTypes = {
  onClick: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  className: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
};

export default DrawerControl;
